import React, { Component } from 'react';
import "../assets/css/AlternateNumber.css";
import customFetch from "./apicall/api";

class AlternateNumber extends Component {
  constructor(props) {
    super(props);
    console.log("AlternateNumber props:", props);
    this.state = {
      household_id: '',
      household_number: '',
      mobileNumber: '',
      selectedMember: '',
      otherName: '',
      selectedRelation: '',
      familyMembers: [],
      familyMemberNumbers: [],
      relations: [],
      otherRelations: [],
      additionalInfo: [],
      deletionRequests: [],
      primaryMobile: props.primaryMobile || '',
      errors: {},
      loading: false,
      saving: false,
      showDeletePopup: false,
      showDeletionRequests: false,
      selectedMobileForDelete: null,
      deleteReasons: [],
      selectedDeleteReason: '',
      showSuccessPopup: false,
      successMessage: '',
      // OTP related state
      showGenerateOTPButton: false,
      showOTPInput: false,
      otpValue: '',
      isOTPGenerating: false,
      isOTPVerifying: false,
      isOTPVerified: false,
      otpError: '',
      // GPS coordinates
      gpsAddress: '',
      latitude: '',
      longitude: ''
    };
  }

  componentDidMount() {
    let hh_id = '';
    let hh_no = '';
    if (window.Android && typeof window.Android.getDataFromLocalStorage === "function") {
      const data = window.Android.getDataFromLocalStorage("your_key");
      if (data) {
        const tokenParts = data.split(",");
        const tokenData = {};

        tokenParts.forEach((part) => {
          const [key, value] = part.split(":");
          tokenData[key] = value;
        });

        if (tokenData.access_token != ""){
          localStorage.setItem("api_token", tokenData.access_token);
        } else {
          const { api_token } =
            (this.props.location && this.props.location.state) || {};
          localStorage.setItem("api_token", api_token);
        }
        
        hh_id = tokenData.household_id || this.props.location.state.householdId || hh_id;
        hh_no = tokenData.household_number || this.props.location.state.household_number || hh_no;
      }
    } else {
      hh_id = this.props.location.state.householdId;
      hh_no = this.props.location.state.household_number;
      console.error(
        "Error in AndroidInterface: Android method not found or not available."
      );
      // Handle the error gracefully
    }
    this.setState({
      household_id: hh_id,
      household_number: hh_no
    }, () => {
      this.fetchHouseholdData();
    });
    console.log('AlternateNumber component mounted');
    this.fetchRelations();
    this.fetchDeleteReasons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.householdId !== this.props.householdId) {
      this.setState({
        household_id: this.props.householdId,
        primaryMobile: this.props.primaryMobile || ''
      }, () => {
        this.fetchHouseholdData();
      });
    }
  }

  // Fetch delete reasons
  fetchDeleteReasons = async () => {
    try {
      const response = await customFetch(
        `${process.env.REACT_APP_URL}/mobile/update/reasons?reason_type_id=3`,
        { 
          method: 'GET',
          headers: {
            "api-token": localStorage.getItem("api_token")
          }
        }
      );

      const data = await response.json();
      console.log("Delete reasons data:", data);

      if (data.data) {
        this.setState({ deleteReasons: data.data });
      } else {
        this.setState({ deleteReasons: [] });
      }
    } catch (error) {
      console.error('Error fetching delete reasons:', error);
      this.setState({ deleteReasons: [] });
    }
  };

  // Fetch household members and additional info
  fetchHouseholdData = async () => {
    const { household_id } = this.state;
    console.log("in fetchHouseholdData: ", household_id);
    
    if (!household_id) return;

    this.setState({ loading: true });

    try {
      // Fetch additional info
      const infoParams = { household_id: household_id };
      const infoQueryParams = new URLSearchParams(infoParams).toString();
      
      const infoResponse = await customFetch(
        `${process.env.REACT_APP_URL}/fetch/household/info?${infoQueryParams}`,
        { 
          method: 'GET',
          headers: {
            "api-token": localStorage.getItem("api_token")
          }
        }
      );

      const infoData = await infoResponse.json();
      console.log("infoData", infoData);

      if (infoData.status === 1) {
        const additionalInfo = infoData.additional_info_details || [];
        const familyMemberNumbers = infoData.family_member_no_details || [];
        
        // Separate active numbers and deletion requests from additional_info_details
        const activeNumbers = additionalInfo.filter(info => !info.is_deleted && !info.reason_for_delete);
        const deletionRequests = additionalInfo.filter(info => info.reason_for_delete && !info.is_deleted);
        
        this.setState({ 
          additionalInfo: activeNumbers,
          familyMemberNumbers: familyMemberNumbers, // New state for family member numbers
          deletionRequests: deletionRequests
        });
      } else {
        this.setState({ 
          additionalInfo: [],
          familyMemberNumbers: [],
          deletionRequests: []
        });
      }

      // Fetch household members (for the dropdown)
      const membersParams = { household_id: household_id };
      const membersQueryParams = new URLSearchParams(membersParams).toString();
      
      const membersResponse = await customFetch(
        `${process.env.REACT_APP_URL}/fetch/household/members?${membersQueryParams}`,
        { 
          method: 'GET',
          headers: {
            "api-token": localStorage.getItem("api_token")
          }
        }
      );

      const membersData = await membersResponse.json();
      console.log("membersData", membersData);
      
      if (membersData.status === 1) {
        this.setState({ familyMembers: membersData.family_members || [] });
      } else {
        this.setState({ familyMembers: [] });
      }

    } catch (error) {
      console.error('Error fetching household data:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  // Fetch relations
  fetchRelations = async () => {
    try {
      const response = await customFetch(
        `${process.env.REACT_APP_URL}/fetch/household/relations`,
        { 
          method: 'GET',
          headers: {
            "api-token": localStorage.getItem("api_token")
          }
        }
      );

      const data = await response.json();
      console.log("relationsData", data);

      if (data.status === 1) {
        this.setState({
          relations: data.relations || [],
          otherRelations: data.other_relations || []
        });
      } else {
        this.setState({
          relations: [],
          otherRelations: []
        });
      }
    } catch (error) {
      console.error('Error fetching relations:', error);
      this.setState({
        relations: [],
        otherRelations: []
      });
    }
  };

  // Handle delete icon click
  handleDeleteClick = (mobileInfo) => {
    this.setState({
      showDeletePopup: true,
      selectedMobileForDelete: mobileInfo,
      selectedDeleteReason: ''
    });
  };

  // Handle deletion request
  handleRaiseForDeletion = async () => {
    const { selectedMobileForDelete, selectedDeleteReason, household_id, additionalInfo, deletionRequests } = this.state;

    if (!selectedDeleteReason) {
      alert('Please select a reason for deletion');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('household_id', parseInt(household_id).toString());
      formData.append('mobile_no', selectedMobileForDelete.mobile_no);
      formData.append('reason_for_delete', selectedDeleteReason);

      const response = await customFetch(
        `${process.env.REACT_APP_URL}/delete/household/info`,
        { 
          method: 'POST',
          headers: {
            "api-token": localStorage.getItem("api_token")
          },
          body: formData
        }
      );

      const result = await response.json();
      console.log('Delete API response:', result);

      if (result.status === 1) {
        // Update state immediately to reflect changes
        const updatedAdditionalInfo = additionalInfo.filter(
          info => info.mobile_no !== selectedMobileForDelete.mobile_no
        );
        
        const newDeletionRequest = {
          ...selectedMobileForDelete,
          reason_for_delete: selectedDeleteReason,
          is_deleted: false // Marked for deletion but not yet approved
        };

        this.setState({
          showDeletePopup: false,
          showSuccessPopup: true,
          successMessage: result.message || 'Deletion request raised successfully!',
          selectedMobileForDelete: null,
          selectedDeleteReason: '',
          additionalInfo: updatedAdditionalInfo,
          deletionRequests: [...deletionRequests, newDeletionRequest]
        });

        // Optional: Refresh data from server after successful deletion request
        setTimeout(() => {
          this.fetchHouseholdData();
        }, 1000);
      } else {
        alert(result.message || 'Failed to raise deletion request');
      }
    } catch (error) {
      console.error('Error raising deletion request:', error);
      alert('Error raising deletion request: ' + error.message);
    }
  };

  // Handle approve deletion
  handleApproveDeletion = async (mobileInfo) => {
    try {
      const formData = new FormData();
      formData.append('household_id', parseInt(this.state.household_id).toString());
      formData.append('mobile_no', mobileInfo.mobile_no);
      formData.append('reason_for_delete', mobileInfo.reason_for_delete || 'Number no longer in use');
      formData.append('flag', 'approve');

      const response = await customFetch(
        `${process.env.REACT_APP_URL}/delete/household/info`,
        { 
          method: 'POST',
          headers: {
            "api-token": localStorage.getItem("api_token")
          },
          body: formData
        }
      );

      const result = await response.json();
      console.log('Approve deletion response:', result);

      if (result.status === 1) {
        // Remove from deletion requests immediately
        const updatedDeletionRequests = this.state.deletionRequests.filter(
          request => request.mobile_no !== mobileInfo.mobile_no
        );

        this.setState({
          showSuccessPopup: true,
          successMessage: result.message || 'Number deleted successfully!',
          deletionRequests: updatedDeletionRequests
        });

        // Refresh data from server
        setTimeout(() => {
          this.fetchHouseholdData();
        }, 1000);
      } else {
        alert(result.message || 'Failed to delete number');
      }
    } catch (error) {
      console.error('Error approving deletion:', error);
      alert('Error approving deletion: ' + error.message);
    }
  };

  // Handle reject deletion
  handleRejectDeletion = async (mobileInfo) => {
    try {
      const formData = new FormData();
      formData.append('household_id', parseInt(this.state.household_id).toString());
      formData.append('mobile_no', mobileInfo.mobile_no);
      formData.append('reason_for_delete', mobileInfo.reason_for_delete || 'Number no longer in use');
      formData.append('flag', 'reject');

      const response = await customFetch(
        `${process.env.REACT_APP_URL}/delete/household/info`,
        { 
          method: 'POST',
          headers: {
            "api-token": localStorage.getItem("api_token")
          },
          body: formData
        }
      );

      const result = await response.json();
      console.log('Reject deletion response:', result);

      if (result.status === 1) {
        // Remove from deletion requests and add back to additional info
        const updatedDeletionRequests = this.state.deletionRequests.filter(
          request => request.mobile_no !== mobileInfo.mobile_no
        );

        const { reason_for_delete, ...mobileInfoWithoutReason } = mobileInfo;

        this.setState({
          showSuccessPopup: true,
          successMessage: result.message || 'Deletion request rejected successfully!',
          deletionRequests: updatedDeletionRequests,
          additionalInfo: [...this.state.additionalInfo, mobileInfoWithoutReason]
        });

        // Refresh data from server
        setTimeout(() => {
          this.fetchHouseholdData();
        }, 1000);
      } else {
        alert(result.message || 'Failed to reject deletion request');
      }
    } catch (error) {
      console.error('Error rejecting deletion:', error);
      alert('Error rejecting deletion: ' + error.message);
    }
  };

  // Handle input changes
  handleInputChange = (field, value) => {
    this.setState({
      [field]: value,
      errors: {
        ...this.state.errors,
        [field]: ''
      }
    });

    if (field === 'selectedMember') {
      if (value !== '0') {
        this.setState({ 
          otherName: '',
          selectedRelation: '',
          showGenerateOTPButton: true,
          showOTPInput: true,
          otpValue: '',
          isOTPVerified: false,
          otpError: ''
        });
      } else {
        this.setState({ 
          selectedRelation: '',
          showGenerateOTPButton: false,
          showOTPInput: false,
          otpValue: '',
          isOTPVerified: false,
          otpError: ''
        });
      }
    }
  };

  // Get current relations based on selected member
  getCurrentRelations = () => {
    const { selectedMember, relations, otherRelations } = this.state;
    
    if (selectedMember === '0') {
      // For "Other" family member, return other_relations with unique keys
      return otherRelations.map((relation, index) => ({
        ...relation,
        uniqueId: `other-${index}`,
        family_relation_value: relation.family_relation_name
      }));
    }
    
    // For regular family members, return normal relations
    return relations.map(relation => ({
      ...relation,
      family_relation_value: relation.family_relation_id.toString()
    }));
  };

  // Mobile number validation
  validateMobileNumber = (number) => {
    const errors = {};
    const cleanedNumber = number.replace(/\D/g, '');

    if (!cleanedNumber) {
      errors.mobileNumber = 'Mobile number is required';
      return errors;
    }

    if (cleanedNumber.length !== 10) {
      errors.mobileNumber = 'Mobile number must be exactly 10 digits';
      return errors;
    }

    if (!/^[6-9]/.test(cleanedNumber)) {
      errors.mobileNumber = 'Mobile number must start with 6, 7, 8, or 9';
      return errors;
    }

    // Comprehensive sequential number patterns including blacklisted numbers
    const sequentialPatterns = [
      // /6789012345|7890123456|8901234567|9012345678/, // Forward sequences
      // /9876543210|8765432109|7654321098|6543210987/, // Reverse sequences
      /6666666666|7777777777|8888888888|9999999999/, // All same digits
      // Blacklisted specific numbers
      /^8888888888$|^9191919191$|^1231231234$|^1234512345$|^1111111111$|^2222222222$|^3333333333$|^4444444444$|^5555555555$|^6666666666$|^7777777777$|^9999999999$|^1212121212$|^1313131313$|^1414141414$|^1515151515$|^1616161616$|^1717171717$|^1818181818$|^1919191919$|^2121212121$|^2323232323$|^2525252525$|^2727272727$|^2929292929$|^3434343434$|^4545454545$|^5656565656$|^6767676767$|^7878787878$|^8989898989$/
    ];

    // Check for sequential patterns
    const isSequential = sequentialPatterns.some(pattern => pattern.test(cleanedNumber));
    if (isSequential) {
      errors.mobileNumber = 'Sequential numbers are not allowed';
      return errors;
    }

    // Repeated digit patterns (all same digits)
    // if (/^(\d)\1{9}$/.test(cleanedNumber)) {
    //   errors.mobileNumber = 'Repeated digit numbers are not allowed';
    //   return errors;
    // }

    // Pattern with repeated pairs (e.g., 8181818181, 1212121212)
    if (/^(\d{2})\1{4}$/.test(cleanedNumber)) {
      errors.mobileNumber = 'Repeating pattern numbers are not allowed';
      return errors;
    }

    // Pattern with repeated triplets (e.g., 8768768760)
    // if (/^(\d{3})\1{2}\d$/.test(cleanedNumber)) {
    //   errors.mobileNumber = 'Repeating pattern numbers are not allowed';
    //   return errors;
    // }

    // Incremental patterns (e.g., 9865412345, 7878245678 with step)
    // const incrementalPatterns = [
    //   /^(?:0[13579]|1[24680]|2[35791]|3[46802]|4[57913]|5[68024]|6[79135]|7[80246]|8[91357]|9[02468]){5}$/, // Odd-even alternation
    //   /^([0-9])([0-9])\1\2\1\2\1\2\1\2$/, // ABABABABAB pattern
    // ];

    // const isIncremental = incrementalPatterns.some(pattern => pattern.test(cleanedNumber));
    // if (isIncremental) {
    //   errors.mobileNumber = 'Pattern-based numbers are not allowed';
    //   return errors;
    // }

    // Common dummy number patterns
    const dummyPatterns = [
      /^[6-9]0{9}$/, // Number followed by all zeros (e.g., 8000000000, 9000000000)
      /^[6-9]1{9}$/, // Number followed by all ones (e.g., 8111111111)
      /^[6-9]2{9}$/, // Number followed by all twos
      /^[6-9]3{9}$/, // Number followed by all threes
      /^[6-9]4{9}$/, // Number followed by all fours
      /^[6-9]5{9}$/, // Number followed by all fives
      /^[6-9]6{9}$/, // Number followed by all sixes
      /^[6-9]7{9}$/, // Number followed by all sevens
      /^[6-9]8{9}$/, // Number followed by all eights
      /^[6-9]9{9}$/, // Number followed by all nines
      // /^[6-9]0{5}\d{4}$/, // First digit followed by 5 zeros (e.g., 8000001234)
      // /^[6-9]\d{4}0{5}$/, // Last 5 digits as zeros
      // /^[6-9](\d)\1{8}$/, // Any repeated digit pattern
    ];

    const isDummy = dummyPatterns.some(pattern => pattern.test(cleanedNumber));
    if (isDummy) {
      errors.mobileNumber = 'This number pattern is not allowed';
      return errors;
    }

    // Palindrome check (numbers that read same forward and backward e.g., 9832002389)
    // const isPalindrome = cleanedNumber === cleanedNumber.split('').reverse().join('');
    // if (isPalindrome && cleanedNumber !== cleanedNumber[0].repeat(10)) {
    //   errors.mobileNumber = 'Palindrome numbers are not allowed';
    //   return errors;
    // }

    // Arithmetic progression check (numbers with constant difference)
    // const digits = cleanedNumber.split('').map(Number);
    // const differences = [];
    // for (let i = 1; i < digits.length; i++) {
    //   differences.push(digits[i] - digits[i - 1]);
    // }
    // const allSameDifference = differences.every(diff => diff === differences[0]);
    // if (allSameDifference && Math.abs(differences[0]) > 0 && Math.abs(differences[0]) <= 3) {
    //   errors.mobileNumber = 'Arithmetic sequence numbers are not allowed';
    //   return errors;
    // }

    // Blacklisted numbers - MOVED TO sequentialPatterns above
    // const blacklistedNumbers = [
    // ];
    
    // if (blacklistedNumbers.includes(cleanedNumber)) {
    //   errors.mobileNumber = 'This number is not allowed';
    //   return errors;
    // }

    if (cleanedNumber === this.state.primaryMobile) {
      errors.mobileNumber = 'Cannot use primary mobile number as alternate number';
      return errors;
    }

    const isDuplicate = this.state.additionalInfo.some(info => 
      info.mobile_no === cleanedNumber
    );
    if (isDuplicate) {
      errors.mobileNumber = 'This number is already added for this household';
      return errors;
    }

    return errors;
  };

  handleMobileNumberChange = (value) => {
    const cleanedValue = value.replace(/\D/g, '');
    this.setState({
      mobileNumber: cleanedValue,
      errors: {
        ...this.state.errors,
        mobileNumber: ''
      }
    });
  };

  validateForm = () => {
    const { mobileNumber, selectedMember, selectedRelation, otherName } = this.state;
    const errors = {};

    const mobileErrors = this.validateMobileNumber(mobileNumber);
    if (mobileErrors.mobileNumber) {
      errors.mobileNumber = mobileErrors.mobileNumber;
    }

    if (!selectedMember) {
      errors.selectedMember = 'Please select a family member';
    }

    if (!selectedRelation) {
      errors.selectedRelation = 'Please select a relation';
    }

    if (selectedMember === '0' && !otherName.trim()) {
      errors.otherName = 'Please enter the name';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  // Generate OTP
  handleGenerateOTP = async () => {
    const { selectedMember, mobileNumber, gpsAddress, latitude, longitude } = this.state;

    if (!mobileNumber) {
      alert('Please enter a mobile number');
      return;
    }

    if (!selectedMember || selectedMember === '0') {
      alert('Please select a family member');
      return;
    }

    this.setState({ isOTPGenerating: true, otpError: '' });

    try {
      // Prepare JSON payload
      const payload = {
        mobile_no: mobileNumber,
        gps_address: gpsAddress || '',  // Make sure to get this from state
        latitude: latitude || '',         // Make sure to get this from state
        longitude: longitude || ''        // Make sure to get this from state
      };

      const response = await customFetch(
        `${process.env.REACT_APP_PHP_URL}/library/php/generateOTP.php`,
        {
          method: 'POST',
          headers: {
            "api-token": localStorage.getItem("api_token"),
            "Content-Type": "application/json"  // Important: Set JSON content type
          },
          body: JSON.stringify(payload)  // Send as JSON string
        }
      );

      const result = await response.json();
      console.log('Generate OTP response:', result);

      if (result.status === 1) {  // Note: Using status instead of success
        this.setState({
          showOTPInput: true,
          otpValue: '',
          isOTPVerified: false,
          otpError: ''
        });
        alert('OTP sent successfully to ' + mobileNumber);
      } else {
        this.setState({
          otpError: result.message || 'Failed to generate OTP'
        });
        alert(result.message || 'Failed to generate OTP');
      }
    } catch (error) {
      console.error('Error generating OTP:', error);
      this.setState({
        otpError: 'Error generating OTP: ' + error.message
      });
      alert('Error generating OTP: ' + error.message);
    } finally {
      this.setState({ isOTPGenerating: false });
    }
  };

  // Handle OTP input change
  handleOTPInputChange = (value) => {
    // Only allow digits, max 6
    const cleanedValue = value.replace(/\D/g, '').slice(0, 6);
    this.setState({
      otpValue: cleanedValue,
      otpError: ''
    });
  };

  // Verify OTP
  handleVerifyOTP = async () => {
    const { otpValue, mobileNumber, gpsAddress, latitude, longitude } = this.state;

    if (!otpValue || otpValue.length !== 6) {
      this.setState({
        otpError: 'Please enter a valid 6-digit OTP'
      });
      alert('Please enter a valid 6-digit OTP');
      return;
    }

    this.setState({ isOTPVerifying: true, otpError: '' });

    try {
      // Prepare JSON payload
      const payload = {
        mobile_no: mobileNumber,
        otp: otpValue,
        gps_address: gpsAddress || '',
        latitude: latitude || '',
        longitude: longitude || ''
      };

      const response = await customFetch(
        `${process.env.REACT_APP_PHP_URL}/library/php/validateOTP.php`,
        {
          method: 'POST',
          headers: {
            "api-token": localStorage.getItem("api_token"),
            "Content-Type": "application/json"  // Important: Set JSON content type
          },
          body: JSON.stringify(payload)  // Send as JSON string
        }
      );

      const result = await response.json();
      console.log('Verify OTP response:', result);

      if (parseInt(result.status) === 1) {  // Handle both string and number status
        this.setState({
          isOTPVerified: true,
          otpError: ''
        });
        alert('Mobile number verified successfully!');
      } else {
        this.setState({
          otpError: result.message || 'Invalid OTP'
        });
        alert(result.message || 'Invalid OTP. Please try again.');
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      this.setState({
        otpError: 'Error verifying OTP: ' + error.message
      });
      alert('Error verifying OTP: ' + error.message);
    } finally {
      this.setState({ isOTPVerifying: false });
    }
  };

  // Render OTP Input squares
  renderOTPInput = () => {
    const { showOTPInput, otpValue, isOTPVerifying, otpError, isOTPVerified } = this.state;

    if (!showOTPInput) return null;

    const otpDigits = otpValue.split('');

    return (
      <div className="otp-section" style={{ marginTop: '20px' }}>
        <div className="form-group-number">
          <label>Enter OTP (6 digits) *</label>
          <div className="otp-input-container" style={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '15px'
          }}>
            {[0, 1, 2, 3, 4, 5].map((index) => (
              <input
                key={index}
                ref={(ref) => {
                  if (!this.otpInputs) this.otpInputs = {};
                  this.otpInputs[index] = ref;
                }}
                type="text"
                inputMode="numeric"
                maxLength="1"
                className="otp-input-box"
                style={{
                  width: '50px',
                  height: '50px',
                  fontSize: '24px',
                  textAlign: 'center',
                  border: '2px solid #007BFF',
                  borderRadius: '8px',
                  backgroundColor: otpDigits[index] ? '#e3f2fd' : '#fff',
                  outline: 'none',
                  transition: 'all 0.3s ease'
                }}
                value={otpDigits[index] || ''}
                onChange={(e) => {
                  const newOtpValue = otpValue.split('');
                  newOtpValue[index] = e.target.value.replace(/\D/g, '');
                  this.handleOTPInputChange(newOtpValue.join(''));
                  
                  // Auto-focus next input
                  if (newOtpValue[index] && index < 5 && this.otpInputs && this.otpInputs[index + 1]) {
                    setTimeout(() => {
                      this.otpInputs[index + 1].focus();
                    }, 50);
                  }
                }}
                onKeyDown={(e) => {
                  // Handle backspace for previous input
                  if (e.key === 'Backspace' && !otpDigits[index] && index > 0 && this.otpInputs && this.otpInputs[index - 1]) {
                    this.otpInputs[index - 1].focus();
                  }
                }}
              />
            ))}
          </div>
        </div>

        {otpError && (
          <div style={{ 
            textAlign: 'center',
            marginBottom: '10px'
          }}>
            <span className="error-text" style={{ color: 'red', fontSize: '14px' }}>{otpError}</span>
          </div>
        )}

        {isOTPVerified && (
          <div style={{ 
            textAlign: 'center',
            marginBottom: '10px'
          }}>
            <span className="success-text" style={{ color: 'green', fontSize: '14px' }}>Mobile number verified successfully!</span>
          </div>
        )}

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '15px',
          pointerEvents: 'auto'
        }}>
          <button
            className="verify-otp-btn"
            onClick={this.handleVerifyOTP}
            disabled={isOTPVerifying || otpValue.length !== 6}
            type="button"
            style={{
              backgroundColor: '#007BFF',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '4px',
              cursor: isOTPVerifying || otpValue.length !== 6 ? 'not-allowed' : 'pointer',
              opacity: isOTPVerifying || otpValue.length !== 6 ? 0.6 : 1,
              pointerEvents: 'auto',
              zIndex: 10
            }}
          >
            {isOTPVerifying ? 'Verifying...' : 'Verify OTP'}
          </button>
        </div>
      </div>
    );
  };

  handleSave = async () => {
    const { selectedMember, isOTPVerified } = this.state;

    // If Family Member is selected (not "Other"), OTP must be verified
    if (selectedMember && selectedMember !== '0' && !isOTPVerified) {
      alert('Please verify the OTP before saving');
      return;
    }

    if (!this.validateForm()) return;

    this.setState({ saving: true });

    try {
      const { mobileNumber, selectedMember, selectedRelation, otherName, household_id, otherRelations, relations } = this.state;

      const formData = new FormData();
      formData.append('household_id', parseInt(household_id).toString());
      formData.append('mobile_no', mobileNumber.replace(/\D/g, ''));
      formData.append('family_member_id', parseInt(selectedMember).toString());
      
      // Fix: Properly handle relation ID and name for other relations
      if (parseInt(selectedMember) === 0) {
        // For "Other" family member, we're using other_relations
        formData.append('relation_id', '0'); // Always use 0 for other relations
        
        // Find the selected relation name from other_relations
        const selectedRelationObj = otherRelations.find(rel => 
          rel.family_relation_name === selectedRelation
        );
        
        if (selectedRelationObj) {
          formData.append('relation_name', selectedRelationObj.family_relation_name);
        } else {
          formData.append('relation_name', selectedRelation || 'Other');
        }
        
        formData.append('family_member_name', otherName.trim());
      } else {
        // For regular family members, use relations with proper ID
        formData.append('relation_id', parseInt(selectedRelation).toString());
        
        // Find the relation name from relations
        const selectedRelationObj = relations.find(rel => 
          rel.family_relation_id === parseInt(selectedRelation)
        );
        
        if (selectedRelationObj) {
          formData.append('relation_name', selectedRelationObj.family_relation_name);
        }
      }

      const response = await customFetch(
        `${process.env.REACT_APP_URL}/add/household/info`,
        { 
          method: 'POST',
          headers: {
            "api-token": localStorage.getItem("api_token")
          },
          body: formData
        }
      );

      const result = await response.json();

      if (result.status === 1) {
        await this.fetchHouseholdData();
        this.setState({
          mobileNumber: '',
          selectedMember: '',
          otherName: '',
          selectedRelation: '',
          showSuccessPopup: true,
          successMessage: result.message || 'Alternate number added successfully!'
        });
      } else {
        this.setState({
          showSuccessPopup: true,
          successMessage: result.message || 'Failed to add alternate number'
        });
      }
    } catch (error) {
      console.error('Error saving alternate number:', error);
      this.setState({
        showSuccessPopup: true,
        successMessage: 'Error saving alternate number: ' + error.message
      });
    } finally {
      this.setState({ saving: false });
    }
  };

  // Render methods for popups
  renderDeletePopup = () => {
    const { showDeletePopup, selectedMobileForDelete, deleteReasons, selectedDeleteReason } = this.state;

    if (!showDeletePopup || !selectedMobileForDelete) return null;

    return (
      <div className="modal-backdrop">
        <div className="modal-content">
          <div className="delete-popup">
            <h3>Delete Alternate Number</h3>
            <div className="mobile-details">
              <p><strong>Mobile Number:</strong> {selectedMobileForDelete.mobile_no}</p>
              <p><strong>Family Member:</strong> {selectedMobileForDelete.family_member_name}</p>
              <p><strong>Relation:</strong> {selectedMobileForDelete.relation_name}</p>
            </div>
            
            <div className="form-group-number">
              <label>Reason for Deletion *</label>
              <select
                value={selectedDeleteReason}
                onChange={(e) => this.setState({ selectedDeleteReason: e.target.value })}
                className="form-control-number"
              >
                <option value="">Select Reason</option>
                {deleteReasons.map(reason => (
                  <option key={reason.id} value={reason.reason_description}>
                    {reason.reason_description}
                  </option>
                ))}
              </select>
            </div>

            <div className="popup-buttons">
              <button 
                className="btn-cancel"
                onClick={() => this.setState({ 
                  showDeletePopup: false, 
                  selectedMobileForDelete: null,
                  selectedDeleteReason: '' 
                })}
              >
                Cancel
              </button>
              <button 
                className="btn-delete"
                onClick={this.handleRaiseForDeletion}
                disabled={!selectedDeleteReason}
              >
                Raise for Deletion
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderSuccessPopup = () => {
    const { showSuccessPopup, successMessage } = this.state;

    if (!showSuccessPopup) return null;

    return (
      <div className="modal-backdrop">
        <div className="modal-content">
          <div className="success-popup">
            <h3>Success</h3>
            <p>{successMessage}</p>
            <button 
              className="btn-ok"
              onClick={() => this.setState({ showSuccessPopup: false })}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderDeletionRequests = () => {
    const { deletionRequests } = this.state;

    return (
      <div className="deletion-requests-section">
        <h3>Deletion Requests</h3>
        {deletionRequests.length === 0 ? (
          <p className="no-requests">No deletion requests</p>
        ) : (
          <div className="requests-grid">
            {deletionRequests.map((request, index) => (
              <div key={index} className="request-tile">
                <div className="request-info">
                  <div className="request-header">
                    <span className="request-mobile">{request.mobile_no}</span>
                    {request.accept_reject_can_display && (
                      <div className="request-action-buttons">
                        <button
                          className="approve-icon"
                          onClick={() => this.handleApproveDeletion(request)}
                          title="Approve Deletion"
                          style={{ 
                            background: 'none', 
                            border: 'none', 
                            cursor: 'pointer',
                            padding: '0'
                          }}
                        >
                          <img
                            src={require("../assets/images/Approve.jpeg")}
                            className="approve-icon-img"
                            alt="Approve"
                            style={{ width: '50px', height: '50px' }}
                          />
                        </button>
                        <button
                          className="reject-icon"
                          onClick={() => this.handleRejectDeletion(request)}
                          title="Reject Deletion"
                          style={{ 
                            background: 'none', 
                            border: 'none', 
                            cursor: 'pointer',
                            padding: '0',
                          }}
                        >
                          <img
                            src={require("../assets/images/Reject_Number.png")}
                            className="reject-icon-img"
                            alt="Reject"
                            style={{ width: '50px', height: '50px' }}
                          />
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="request-details">
                    <span className="request-name">{request.family_member_name}</span>
                    <span className="request-relation">{request.relation_name}</span>
                    <span className="request-reason">Reason: {request.reason_for_delete}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  render() {
    const {
      mobileNumber,
      selectedMember,
      otherName,
      selectedRelation,
      familyMembers,
      additionalInfo,
      familyMemberNumbers,
      errors,
      loading,
      saving,
      household_id,
      household_number,
      showDeletionRequests,
      showGenerateOTPButton,
      showOTPInput,
      otpValue,
      isOTPGenerating,
      isOTPVerifying,
      isOTPVerified,
      otpError
    } = this.state;

    const currentRelations = this.getCurrentRelations();

    return (
      <div className="alternate-number-container">
        <div className="alternate-number-header">
          <h2>Additional Mobile Numbers</h2>
          <p>Household Number: {household_number}</p>
          
          <div className="header-buttons">
            <button 
              className={`btn-toggle ${!showDeletionRequests ? 'active' : ''}`}
              onClick={() => this.setState({ showDeletionRequests: false })}
            >
              Alternate Numbers
            </button>
            <button 
              className={`btn-toggle ${showDeletionRequests ? 'active' : ''}`}
              onClick={() => this.setState({ showDeletionRequests: true })}
            >
              Deletion Requests
            </button>
          </div>
        </div>

        {loading ? (
          <div className="loading-container">Loading...</div>
        ) : showDeletionRequests ? (
          this.renderDeletionRequests()
        ) : (
          <>
            {/* Display Family Member Numbers (from family_member_no_details) */}
            {familyMemberNumbers.length > 0 && (
              <div className="family-numbers-section">
                <h3>Family Member Numbers</h3>
                <div className="numbers-grid">
                  {familyMemberNumbers.map((info, index) => (
                    <div key={`family-${index}`} className="number-tile family-tile">
                      <div className="number-info">
                        <div className="number-display">
                          <span className="mobile-number">{info.mobile_no}</span>
                          <div className="action-buttons">
                            <button
                              className="call_icon_bg mx-1"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                this.handleCall(info.mobile_no);
                              }}
                              style={{ 
                                background: '#4BAE4F', 
                                border: 'none', 
                                cursor: 'pointer',
                                padding: '8px',
                                borderRadius: '50px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              title="Call"
                            >
                              <img
                                src={require("../assets/images/telephone (2).png")}
                                className="call_icon_img"
                                alt="Call"
                                style={{ width: '20px', height: '20px' }}
                              />
                            </button>
                            {/* No delete button for family member numbers */}
                          </div>
                        </div>
                        <div className="details">
                          <span className="name">
                            {this.formatName(info.family_member_name)}
                          </span>
                          <span className="relation">{info.family_relation_name}</span>
                          <span className="member-type">Family Member</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Display Existing Alternate Numbers (from additional_info_details) */}
            <div className="existing-numbers-section">
              <h3>Existing Alternate Numbers</h3>
              {additionalInfo.length === 0 ? (
                <p className="no-numbers">No alternate numbers added yet</p>
              ) : (
                <div className="numbers-grid">
                  {additionalInfo.map((info, index) => (
                    <div key={`additional-${index}`} className="number-tile alternate-tile">
                      <div className="number-info">
                        <div className="number-display">
                          <span className="mobile-number">{info.mobile_no}</span>
                          <div className="action-buttons">
                            <button
                              className="call_icon_bg mx-1"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                this.handleCall(info.mobile_no);
                              }}
                              style={{ 
                                background: '#4BAE4F', 
                                border: 'none', 
                                cursor: 'pointer',
                                padding: '8px',
                                borderRadius: '50px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              title="Call"
                            >
                              <img
                                src={require("../assets/images/telephone (2).png")}
                                className="call_icon_img"
                                alt="Call"
                                style={{ width: '20px', height: '20px' }}
                              />
                            </button>
                            <button
                              className="delete-btn"
                              onClick={() => this.handleDeleteClick(info)}
                              title="Delete"
                              style={{ 
                                background: 'none', 
                                border: 'none', 
                                cursor: 'pointer',
                                padding: '0'
                              }}
                            >
                              <img
                                src={require("../assets/images/Approve.jpeg")}
                                className="delete-icon-img"
                                alt="Delete"
                                style={{ width: '50px', height: '50px' }}
                              />
                            </button>
                          </div>
                        </div>
                        <div className="details">
                          <span className="name">
                            {this.formatName(info.family_member_name)}
                          </span>
                          <span className="relation">{info.relation_name}</span>
                          <span className="added-date">{new Date(info.added_at).toLocaleDateString()}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Add new alternate number form */}
            <div className="add-number-section">
              <h3>Add New Alternate Number</h3>
              
              <div className="form-group-number">
                <label htmlFor="mobileNumber">Mobile Number *</label>
                <input
                  id="mobileNumber"
                  type="text"
                  className={`form-control-number ${errors.mobileNumber ? 'error' : ''}`}
                  placeholder="Add 10-digit mobile number"
                  value={mobileNumber}
                  onChange={(e) => this.handleMobileNumberChange(e.target.value)}
                  maxLength={10}
                />
                {errors.mobileNumber && (
                  <span className="error-text">{errors.mobileNumber}</span>
                )}
              </div>

              <div className="form-group-number">
                <label htmlFor="selectedMember">Family Member *</label>
                <div style={{
                  display: 'flex',
                  gap: '10px',
                  alignItems: 'flex-start'
                }}>
                  <select
                    id="selectedMember"
                    className={`form-control-number ${errors.selectedMember ? 'error' : ''}`}
                    value={selectedMember}
                    onChange={(e) => this.handleInputChange('selectedMember', e.target.value)}
                    style={{ flex: 1 }}
                  >
                    <option value="">Select Family Member</option>
                    {familyMembers.map((member) => (
                      <option key={member.family_member_id} value={member.family_member_id}>
                        {member.family_member_name}
                      </option>
                    ))}
                  </select>
                  {this.state.showGenerateOTPButton && this.state.selectedMember && this.state.selectedMember !== '0' && (
                    <button
                      className="generate-otp-btn"
                      onClick={this.handleGenerateOTP}
                      disabled={this.state.isOTPGenerating || this.state.isOTPVerified}
                      style={{
                        backgroundColor: '#007BFF',
                        color: 'white',
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: this.state.isOTPGenerating || this.state.isOTPVerified ? 'not-allowed' : 'pointer',
                        opacity: this.state.isOTPGenerating || this.state.isOTPVerified ? 0.6 : 1,
                        whiteSpace: 'nowrap',
                        marginTop: '5px'
                      }}
                    >
                      {this.state.isOTPGenerating ? 'Generating...' : this.state.isOTPVerified ? 'OTP Verified ✓' : 'Generate OTP'}
                    </button>
                  )}
                </div>
                {errors.selectedMember && (
                  <span className="error-text">{errors.selectedMember}</span>
                )}
              </div>

              {/* OTP Input Section - Moved before Relation field */}
              {this.renderOTPInput()}

              {selectedMember === '0' && (
                <div className="form-group-number">
                  <label htmlFor="otherName">Person Name *</label>
                  <input
                    id="otherName"
                    type="text"
                    className={`form-control-number ${errors.otherName ? 'error' : ''}`}
                    placeholder="Enter person's name"
                    value={otherName}
                    onChange={(e) => this.handleInputChange('otherName', e.target.value)}
                  />
                  {errors.otherName && (
                    <span className="error-text">{errors.otherName}</span>
                  )}
                </div>
              )}

              <div className="form-group-number">
                <label htmlFor="selectedRelation">Relation *</label>
                <select
                  id="selectedRelation"
                  className={`form-control-number ${errors.selectedRelation ? 'error' : ''}`}
                  value={selectedRelation}
                  onChange={(e) => this.handleInputChange('selectedRelation', e.target.value)}
                >
                  <option value="">Select Relation</option>
                  {currentRelations.map((relation) => (
                    <option 
                      key={relation.uniqueId || relation.family_relation_id} 
                      value={relation.family_relation_value}
                    >
                      {relation.family_relation_name}
                    </option>
                  ))}
                </select>
                {errors.selectedRelation && (
                  <span className="error-text">{errors.selectedRelation}</span>
                )}
              </div>

              <button
                className="save-btn"
                onClick={this.handleSave}
                disabled={saving || (this.state.selectedMember && this.state.selectedMember !== '0' && !this.state.isOTPVerified)}
              >
                {saving ? 'Saving...' : 'Save Alternate Number'}
              </button>
            </div>
          </>
        )}

        {/* Popups */}
        {this.renderDeletePopup()}
        {this.renderSuccessPopup()}
      </div>
    );
  }

  formatName = (name) => {
    return name.length > 8 ? name.substring(0, 8) + '...' : name;
  };

  handleCall = (mobileNumber) => {
    window.open(`tel:+91${mobileNumber}`, '_self');
  };
}

export default AlternateNumber;